export const downloadedData = 'DOWNLOADED_DATA_FROM_API';
export const clearedData = 'CLEARED_DATA_FIELD';

export const selectedService = 'SELECTED_SERVICE';
export const selectedCity = 'SELECTED_CITY';
export const selectedAge = 'SELECTED_AGE';
export const selectedRobot = 'SELECTED_ROBOT';
export const selectedLocation = 'SELECTED_LOCATION';
export const selectedOccurrence = 'SELECTED_OCCURRENCE';

// export const clickedNextButton = "CLICKED_NEXT_BUTTON"
// export const clickedBackButton = "CLICKED_BACK_BUTTON"
export const loadedPage = 'LOADED_PAGE';

export const changedMapFilter = 'CHANGED_MAP_FILTER';
export const changedAgreement = 'CHANGED_AGREEMENT';
export const changedContactForm = 'CHANGED_CONTACT_FORM';
export const changedKnownClient = 'CHANGED_KNOWN_CLIENT';

export const changedMapPosition = 'CHANGED_MAP_POSITION';

// export const suggestedPlace = 'PICKED_SUGGESTED_PLACE_OPTION'
export const sentForm = 'SENT_FORM';

export const closedTip = 'CLOSED_TIP';
